<p class="ao-top-16 ao-bottom-32 ao-align-center">
	Your session will expire in <b>{{ idleSecondsRemainingSig() }}</b> second(s) due to inactivity.
</p>
<div class="ao-align-center">
	<button type="button" class="ao-button-primary ao-width-M" (click)="extendSession()">Extend Session</button>
</div>
